import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";

type Props = {
  show?: boolean;
  close: () => void;
  isDisable: boolean;
  disableUser: (fecha: string, descripcion: string) => void;
  enableUser: (fecha: string, descripcion: string) => void;
};


export default function ManageUserStatusModal({show, close, isDisable, disableUser, enableUser}:Props) {
  const [fecha, setFecha] = useState("");
  const [descripcion, setDescripcion] = useState("");


  const handleSave = () => {
    if(isDisable){
      disableUser(fecha, descripcion)
    } else {
      enableUser(fecha, descripcion)
    }
    close();
  };

  return (
    <>
      <Modal show={show} onHide={close}>
        <Modal.Header closeButton>
          
          <Modal.Title>{isDisable ? "Deshabilitar Usuario" : "Habilitar Usuario"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Fecha</Form.Label>
              <Form.Control
                type="date"
                value={fecha}
                onChange={e => setFecha(e.target.value)}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Descripción</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                value={descripcion}
                onChange={e => setDescripcion(e.target.value)}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={close}>
            Cerrar
          </Button>
          <Button variant="primary" onClick={handleSave}>
            Guardar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}